import { z } from "zod/v4";
const SortDirectionList = ["asc", "desc"];
const SortDirectionProperties = {
    asc: {
        label: "昇順",
    },
    desc: {
        label: "降順",
    },
};
const SortDirectionSchema = z.enum(SortDirectionList);
export const SortDirection = {
    schema: SortDirectionSchema,
    list: SortDirectionList,
    ...SortDirectionProperties,
};
//# sourceMappingURL=sort-direction.js.map